export const countriesBySlug = {
    "united-states": {
        id: "US",
        isDiscoverable: true,
        name: "United States",
    },
};
